import { merge } from 'ramda'

import {
  GET_BATTERY_STATUS_REQUEST,
  GET_BATTERY_STATUS_SUCCESS,
  GET_BATTERY_STATUS_FAILURE,
  SET_BATTERY_DEVICE_ID,
} from './constants'

export const initialState = {
  isLoading: false,
  error: '',
  status: null,
  deviceId: null,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_BATTERY_STATUS_REQUEST: {
      return merge(state, { error: '', isLoading: true })
    }
    case GET_BATTERY_STATUS_SUCCESS: {
      return merge(state, {
        status: action.payload,
        isLoading: false,
        error: '',
      })
    }
    case GET_BATTERY_STATUS_FAILURE: {
      return merge(state, { error: action.payload, isLoading: false })
    }
    case SET_BATTERY_DEVICE_ID: {
      return merge(state, { deviceId: action.payload })
    }
    default:
      return state
  }
}

export default reducer
